/**
 * The email builder package's host collaborators, configured once when the
 * builder module loads (the package configures nothing at import).
 *
 *  - stylePatch: the package's own exact `style` attribute writer (legacy
 *    button colours use it; without it those edits are refused).
 *  - layoutFrames / linkSource: the shared-layout ports in ./layout (exact
 *    attribute writes and link checks).
 *  - liquid: deliberately NOT configured. The client never parses or renders
 *    Liquid; the server's validation and preview are authoritative, and the
 *    adapters behave as they do with no checker (edits are kept, problems are
 *    reported by the server).
 */
import { configureSourceDeps, stylePatchApi } from "@v0y4ge/jrni-email-builder";
import { setAttr } from "./layout/layout-frames";
import { linkHrefProblem, linkTextProblem } from "./layout/link-source";

let configured = false;

export function ensureSourceDeps(): void {
  if (configured) return;
  configureSourceDeps({
    stylePatch: stylePatchApi,
    layoutFrames: { setAttr },
    linkSource: { linkTextProblem, linkHrefProblem },
  });
  configured = true;
}
